import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import EnhancedReportsPage from "../components/Analytics/EnhancedReportsPage";

const ReportsPage: React.FC = () => {
    return <EnhancedReportsPage />
}

export default ReportsPage;